export function isNumericCharacter(text: string): boolean {
  if (text === ' ') return false;
  const isNumber = typeof text === 'number';
  return (isNumber || text !== '') && !isNaN(Number(text));
}
